<template>
  <div>
    <Modal v-model="visible" title="提现资料查看" :mask-closable="false" :footer-hide="true" width="900px" class="my-modal top">
      <div class="container-box">
        <div class="label-value">
          <span class="label">业务员姓名</span>
          <span class="value">{{ data.userName }}</span>
        </div>

        <div class="label-value">
          <span class="label">申请金额</span>
          <span class="value">{{ data.requestAmount }}</span>
        </div>

        <div class="label-value">
          <span class="label">申请时间</span>
          <span class="value">{{ data.requestTime | filterTime('YYYY-MM-DD HH:mm') }}</span>
        </div>
      </div>
      <div class="invoice-box">
        <span class="label">发票</span>
        <Upload
          v-model="list"
          accept=".pdf,.png,.jpg"
          fileType=""
          :multiple="true"
          :showFileName="true"
          :maxFileSize="1024 * 50"
          :limit="0"
          :disabled="true"
          ref="upload"
          :showUpload="false"
        ></Upload>
      </div>
    </Modal>
  </div>
</template>

<script>
import Upload from '@/components/commons/Upload/index';
export default {
  components: { Upload },
  data() {
    return {
      visible: false,
      list: [],
      data: {}
    };
  },

  methods: {
    open(item) {
      this.list = JSON.parse(item.detail);
      this.data = item;
      this.visible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.container-box {
  margin-top: 20px;
  display: flex;
  .label-value {
    flex: 1;
    .label {
      margin-right: 15px;
      font-size: 14px;
    }
    .value {
      font-size: 13px;
    }
  }
}
.invoice-box {
  margin-top: 50px;
  display: flex;
  align-items: center;
  .label {
    margin-right: 60px;
  }
}
</style>
